import React,{ useState, useEffect } from "react";
import {Typography,CircularProgress } from '@material-ui/core';
import FormScopeDefiner from "../../../Component/Forms/FormScopeDefiner";
 
// import useStyles    from '../../Component/Theme_1/ComponentCss';
import ThemeControls from "../../../Component/AllThemesControl";
import { APIUIGET } from '../../../services/APIServices';

const apiContextVar = "";
const contextHeading = "";

function Create(props) {
    const { getContext } = props;  // Access context from props
    const {useStyles} = ThemeControls;
    const classes=useStyles();
    const contextClasses = classes.topSpace;
    const contextObjective = "create";
    let sideImageData = {};

    //alert(getContext);

    // Add state for dynamically loaded JSON files
    const [contextJson, setContextJson] = useState(null);
    const [fieldsData, setFieldsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Configure which JSON files to load
    const { 
        masterJsonPath = '/vconfig/'+getContext+'/save.json', 
        viewTablePath =  '/vconfig/'+getContext+'/view.json'
    } = props;

    useEffect(() => {
      const loadJsonFiles = async () => {
          try {
              setLoading(true);
              
              const [masterJsonModule, viewTableModule] = await Promise.all([
                 // APIGET(/* webpackChunkName: "masterJson" */ `${masterJsonPath}`),
                 // import(/* webpackChunkName: "viewTable" */ `${viewTablePath}`)
                 APIUIGET(masterJsonPath),
                 APIUIGET(viewTablePath)
              ]);
              
              // Get default exports
              const masterData = masterJsonModule;
              const viewData = viewTableModule;
             // masterData = APIGET(masterJsonPath);
             // viewData = APIGET(viewTablePath);
              // Process the master JSON as before
              Object.keys(masterData).forEach((key, index) => {
                    if (key !== "xioFEConfig") {
                        masterData[key].fields.map((field) => {
                        if (field.field_type === "custom") {
                          field.field_value = "{}";
                        } else if (field.field_type !== "hidden" && field.field_default_value) {
                          field.field_value = field.field_default_value
                          field.id = ""
                          field.field_helperText = ""
                        } else {
                          field.field_value = "";
                          field.field_helperText = "";
                          field.id = "";
                        }
                        return field; // <-- add this return statement
                      });
                
                      // =---sideIMage---dataAssing--->
                      if (masterData['xioFEConfig'] && masterData['xioFEConfig'].sideImageData) {
                        sideImageData = masterData['xioFEConfig'].sideImageData;
                      }
                    }
                  });
                
              
              setContextJson(masterData);
              setFieldsData(viewData);
              setLoading(false);
          } catch (err) {
              console.error("Failed to load JSON files:", err);
              setError(err.message);
              setLoading(false);
          }
      };
      
      loadJsonFiles();
  }, [masterJsonPath, viewTablePath]);
  

      // Get API context object
      const apiContextObj = fieldsData ? fieldsData.config : {};

      if (loading) {
      return (
          <div className={classes.main} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
              <CircularProgress />
              <Typography variant="body1" style={{ marginLeft: '10px' }}>
                  Loading form configuration...
              </Typography>
          </div>
      );
      }

      if (error) {
      return (
          <div className={classes.main}>
              <Typography variant="h6" color="error">
                  Error loading form: {error}
              </Typography>
          </div>
      );
      }


    return (
      <div className={classes.main}>
          {/* <PolicyImg Image={smsPolicyImg} data={sideImageData}/>  */}
          <div className={classes.formAline}>
            <Typography variant="h6" className={classes.marginChange}>
              {contextHeading}
            </Typography>
          <FormScopeDefiner value={{contextJson,apiContextObj,apiContextVar,contextHeading,contextClasses,contextObjective}}>
          </FormScopeDefiner> 
          </div>
      </div>
    )
  }

  export default Create;
  